import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackInternalNavigation } from '../../utils/nav';

export default function RouteTracker() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      // store the previous internal route
      sessionStorage.setItem('lastInternalRoute', prevPath.current);
      // track internal navigation
      trackInternalNavigation(location.pathname);
      prevPath.current = location.pathname;
    }
  }, [location.pathname]);

  return null;
}
